export default "__VITE_ASSET__yml1OAOb__"